module.exports = "<districts-page></districts-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/districts.html
// module id = 1452
// module chunks = 0